module.exports = __webpack_public_path__ + "img/eastercross.bbfb4d4a.png";